import { useEffect } from "react";
import { Col, Divider, Typography, Row, Card } from "antd";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import LoginSignupScreen from "./loginSignupScreen";
import { css } from "@emotion/css";
import AdminSignupPageCard from "../Global/Components/Onboarding/adminSignupPageCard";

const { Title } = Typography;
function EmailVerification() {
  const router = useNavigate();
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;

  useEffect(() => {
    if (
      sharedUserInfo &&
      sharedUserInfo?.payload?.email &&
      sharedUserInfo?.payload?.type === "user" &&
      sharedUserInfo?.payload?.emailVerification === true
    ) {
      router("/user/dashboard", { replace: true });
    }
  }, [sharedUserInfo]);
  const otpStyle = {
    minHeight: "50vh",
    borderRadius: "32px",
    display: "flex",
    justifyContent: "center",
    /* flex-direction: column; */
    alignItems: "center",
    margin: "20px 0",
    // maxWidth:'200px'
  };
  return (
    <div
      style={{
        backgroundImage: `url("/pics/login/login_background.jpg")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        width: "100%",
        height: "100vh",
        display: "flex",
        position: "fixed",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          width: "100%",
          //   margin: "50px 0",
        }}
      >
        <Col span={20}>
          <Card
            className={css`
              opacity: 0;

              animation: fadeIn 0.5s forwards;
              @keyframes fadeIn {
                from {
                  opacity: 0;
                  transform: translateY(-20px);
                }
                to {
                  opacity: 1;
                  transform: translateY(0);
                }
              }
            `}
            style={otpStyle}
          >
            <Row
              style={{
                display: "flex",
                justifyContent: "center",
                // margin: "0 250px",
              }}
            >
              {/* <Col span={24} style={{ marginBottom: "20px" }}> */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "5px",
                }}
              >
                <Title>Verify your email</Title>
                {}
                <Divider className="form-divider" />

                <p style={{ fontSize: 20 }}>
                  You're in. An email has been sent to your email address. Hit
                  confirm and you'll be ready to start working.
                </p>
              </div>
              {/* </Col> */}
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default EmailVerification;
